import BlogDetail from "../../../commonComponents/blogDetail";

const BlogRightClassicContainer = () => {
  return <BlogDetail type="right" />;
};

export default BlogRightClassicContainer;
